/* eslint-disable operator-linebreak */

/* eslint-disable @typescript-eslint/no-unused-vars */

/* eslint-disable react/no-children-prop */

/* eslint-disable arrow-body-style */
import React, { useEffect, useRef, useState } from 'react';

import eureka from 'eureka';

import eurekaMgrs from '@eureka/ui-managers';
import { MessageStrip } from '@ui5/webcomponents-react/dist/MessageStrip';
import { MessageStripType } from '@ui5/webcomponents-react/dist/MessageStripType';

import DefaultLayout from './DefaultLayout';

const { ProxyHelper } = eurekaMgrs.ProxyManager; // Proxy Helper
// fetchApplicationManifestAssets You need a config as last parameter
// renderApplication you need a config as last parameter
const { fetchApplicationManifestAssets, renderApplication, unmountApplication, fetchManifest } =
  ProxyHelper; // Those are life cycle functions and loading functions for application
// eslint-disable-next-line
const { getCurrentLanguage } = eureka.I18nProvider;
const { Spinner } = eureka.components;

const { UserPreferenceManager, eventBus } = eurekaMgrs;

export const hasLoggedin = () => {
  const login = !!window.hasLoggedin;
  return login;
};
// eslint-disable-next-line
export const defaultGetAppPreference = (name) => {
  return Promise.resolve({
    data: {},
  });
};

export const renderApp = ({ history, match, host, config, name, user, settings, container }) => {
  // call render application to generate shadow dom and relevant scripts, styles and others
  renderApplication(
    name,
    history,
    {
      history,
      match,
      host,
      user,
      eventBus,
      config,
      settings,
    },
    container,
    config /****** This is very important for public path, without this, it will failed ****/,
  );
  /* istanbul ignore next */
};

export const renderMicroFrontend = ({
  history,
  match,
  host,
  config,
  name,
  user,
  settings,
  container,
  fetchManifestError,
  userPreferencePromise,
}) => {
  if (fetchManifestError) {
    return;
  }
  userPreferencePromise
    .then((res) => {
      UserPreferenceManager.setAppSetting(name, res.data);
    })
    .catch((err) => {
      /* istanbul ignore next */
      console.log('Load user preference error:', err);
    })
    .finally(() => {
      renderApp({ history, match, host, config, name, user, settings, container });
    });
};

export const renderContainer = ({ name, containerRef }) => {
  return (
    <div
      id="microfrontend-viewport"
      data-testid={`${name}-microfrontend-render-container`}
      style={{ height: '100%' }}
    >
      <div id={`${name.toLowerCase()}-container`} style={{ height: '100%' }}>
        <div
          id={`${name.toLowerCase()}-content`}
          className="microfrontent-content"
          ref={containerRef}
          style={{ height: '100%', position: 'relative' }}
        >
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              width: '100%',
              height: '100%',
            }}
          >
            <Spinner />
          </div>
        </div>
      </div>
    </div>
  );
};

export const renderError = () => {
  return (
    <MessageStrip
      icon="message-error"
      style={{ margin: '10px' }}
      noCloseButton={false}
      design={MessageStripType.Negative}
    >
      Failed to load asset manifest, please try again.
    </MessageStrip>
  );
};

/* istanbul ignore next */
const MicroFrontend = ({
  name,
  host,
  // eslint-disable-next-line
  document,
  match,
  history,
  config,
  settings,
  user,
  getManifest = null,
  getAppPreference = null,
}) => {
  const [fetchManifestError, setFetchManifestError] = useState(false);
  const containerRef = useRef();
  const userPreferencePromise = (getAppPreference || defaultGetAppPreference)(name);

  useEffect(() => {
    const container = containerRef.current;
    if (name !== 'mfe-login' && !hasLoggedin()) {
      history.push('/login?application=itcm');
    } else if (container) {
      fetchManifest({ host, name, getManifest }).then((manifest) => {
        // manifest host is equal to `http://localhost:2120`
        // Here is first fetch manifest json, and then use the manifest resource to fetch script and css resources
        fetchApplicationManifestAssets(
          manifest,
          manifest?.files['main.js']?.startsWith('http') ? '' : host,
          name,
          config /****** This is very important for public path, without this, it will failed ****/,
        ).then(
          () => {
            // And then to generate MFE
            renderMicroFrontend({
              history,
              match,
              host,
              config,
              name,
              user,
              settings,
              container,
              fetchManifestError,
              userPreferencePromise,
            });
          },
          (err) => {
            console.log('Load main asset error:', err);
            setFetchManifestError(true);
          },
        );
      });
    }

    return () => {
      if (fetchManifestError) {
        return;
      }
      // After life cycle, unmount app
      unmountApplication(name);
    };
    // eslint-disable-next-line
  }, []);

  if (fetchManifestError) {
    return (
      <DefaultLayout
        match={match}
        children={renderError()}
        history={history}
        config={config}
        user={user}
        settings={settings}
      />
    );
  }

  const container = renderContainer({ name, containerRef });

  if (name.toLowerCase() === 'mfe-login') {
    return <div style={{ height: '100%' }}>{container}</div>;
  }

  return (
    <DefaultLayout
      children={container}
      match={match}
      history={history}
      config={config}
      settings={settings}
      user={user}
    />
  );
};

export default MicroFrontend;
